import { render, staticRenderFns } from "./SearchPostalCode.vue?vue&type=template&id=c3defa5a&"
import script from "./SearchPostalCode.vue?vue&type=script&lang=js&"
export * from "./SearchPostalCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports